import { set } from '@imcc/utilities';
import { FilterState, initialState } from '../filter-state';

export function clearReducer(state: FilterState) {
  const { showFilters, aggregations } = state.tabs[state.indexName];
  const { [state.indexName]: initialTabState } = initialState.tabs;
  const clearedState = { ...initialTabState, showFilters, aggregations };

  return set(state, ['tabs', state.indexName], clearedState);
}
